"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStackElementsStyles = void 0;
const useStackElementsStyles = ({ spacing = 0, gap, alignItems = 'flex-start', justifyContent = 'flex-start', direction = 'row', }) => {
    const spacingValues = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40];
    const stack = {
        display: 'flex',
        gap: gap ? `${spacingValues[gap]}px` : `${spacingValues[spacing]}px`,
        alignItems,
        justifyContent,
        flexDirection: direction,
    };
    return { stack };
};
exports.useStackElementsStyles = useStackElementsStyles;
